<template>
  <li :class="[decorated.day, decorated.status_text === 'Cancelled' ? 'load-cancelled': '']">
    <div class="move-margin">

      <p class="load-number">{{ number }}</p>

      <p class="load-reference">
        <router-link :to="{ name: 'loads.show', params: { id: load.id }}">{{ load.reference_number }}</router-link>

        <span class="load-status pull-right" :class="decorated.status_class">{{ decorated.status_text }}</span>
      </p>

      <div class="row">
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p>
            <strong>Loading Date</strong><br>
            {{ decorated.loading_date }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p>
            <strong>Loading Time</strong><br>
            {{ decorated.loading_time }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p>
            <strong>Delivery Date</strong><br>
            {{ decorated.delivery_date }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p>
            <strong>Delivery Time</strong><br>
            {{ decorated.delivery_time}}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p>
            <strong>Load Size</strong><br>
            {{ decorated.size }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p>
            <strong>Net Weight</strong><br>

            {{ decorated.net_weight }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p class="material-details">
            <strong>
              Rate
              <span
                :class="{ 'text-success': isProfitableLoadForArrow, 'text-danger': isNotProfitableLoadForArrow }"
                :title="perTonneDifference">
                {{ arrowProfitAsMoney }}
              </span>
            </strong><br>
            {{ decorated.rate }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p class="load-cost">
            <strong>Client Charge</strong><br>
            {{ clientChargeAsMoney }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 col-sm-8 col-lg-6 col-xl-4">
          <p class="material-details">
            <strong>Carrier</strong><br>
            {{ decorated.company }}

            <router-link v-if="load.carrier" :to="{ name: 'users.edit', params: { id: load.carrier.id } }" target="_blank" class="pull-right"><i class="fa fa-external-link"></i></router-link>
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p class="material-details">
            <strong>Rego</strong><br>
            {{ decorated.registration }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p class="material-details">
            <strong>Driver</strong><br>
            {{ decorated.driver_name }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-1">
          <p class="material-details">
            <strong>Configuration</strong><br>
            {{ decorated.configuration_description }}
          </p>
        </div>
        <div class="col-xs-6 col-sm-4 col-lg-3 col-xl-4">
          <p class="material-details">
            <strong>Weighbridge Details</strong><br>

            <a
              v-if="haveWeighbridge"
              @click="setActiveLoad"
              data-toggle="modal"
              data-target=".modal-load-check">
              View <i class="fa fa-external-link-square"></i>
            </a>
            <span v-else>&ndash;</span>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-8 driver-notes-col">
          <p class="material-details">
            <strong>Driver Notes</strong><br>
            {{ load.notes }}
          </p>
        </div>

        <div class="col-xs-12 col-sm-4 col-lg-2">
          <p class="material-details truncate">
            <strong>Dockets</strong><br>
            <span v-html="dockets ? dockets : '–'"></span>
          </p>
        </div>
      </div>

      <hr v-if="haveCharges" class="m-t-sm m-b-sm">

      <charge v-for="charge in load.charges" :key="charge.id" :charge="charge" :load="load"></charge>
    </div>
  </li>
</template>

<script>
  import { loadHelpers } from 'mixins/loads'
  import Charge from './Charge'

  export default {
    mixins: [loadHelpers],

    components: {
      Charge
    },

    props: ['index', 'load']
  }
</script>

<style scoped>
  .driver-notes-col {
    width: 74.66667%;
  }
  @media (min-width: 1399px) {
    .driver-notes-col {
      width: 62.66667%
    }
  }
</style>



// WEBPACK FOOTER //
// AdminLoad.vue?017de784